import { format } from "rut.js";
import { columns } from "../../../../dtos/columns";
import { institucionFinanciera } from "../models/institucionFinanciera";
import AccionesInstitucion from "../components/accionesInstitucion";

interface IProps {
    control: any;
    setInstitucionEditar: React.Dispatch<React.SetStateAction<institucionFinanciera | undefined>>;
    setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useColumns({ control, setInstitucionEditar, setModalDetalle }: IProps) {

    const COLUMNS: columns<institucionFinanciera>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) =>
                <AccionesInstitucion
                    institucionFinanciera={row}
                    control={control}
                    setInstitucionEditar={setInstitucionEditar}
                    setModalDetalle={setModalDetalle}
                />,
            allowOverflow: true,
            button: true,
            export: false,
            alling: 'center'
        },
        {
            name: 'RUT',
            selector: (row) =>
                format(row.rut),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true
        },
        {
            name: 'Nombre',
            selector: (row) =>
                row.nombre,
            sortable: true,
            sortField: 'nombre',
            wrap: true,
            export: true
        },
        {
            name: 'Activo',
            selector: (row) =>
                row.activo ? 'Si' : 'No',
            sortable: true,
            sortField: 'activo',
            wrap: true,
            export: true
        },
    ]

    return { COLUMNS };
}